<template>
  <v-menu left min-width='20rem' offset-y>
    <span slot="activator">           
      <span v-show="!cxt.isSelectMode()">
      <v-btn v-show="cxt.actionCaption" light :flat="flat">
        {{cxt.actionCaption}}
        <v-icon right>arrow_drop_down</v-icon>
      </v-btn>
      <v-btn v-show="!cxt.actionCaption" icon light>
        <v-icon>{{cxt.actionIcon}}</v-icon>
      </v-btn>
      </span>
      <span v-show="cxt.isSelectMode()">
      <v-btn v-show="!(cxt.isFilterMode() && isMobile)" light :flat="flat">
        Операции
        <v-icon right>arrow_drop_down</v-icon>
      </v-btn>
      <v-btn v-show="cxt.isFilterMode() && isMobile" icon  light :flat="flat">
        <v-icon >arrow_drop_down</v-icon>
      </v-btn>
     </span>
    </span>
    <v-list dense>
      <template v-for="action in this.cxt.getActions()">
      <v-divider v-if="action.divider"></v-divider>
      <v-list-tile v-else :key="action.caption()" v-show="action.isVisible()" @click="action.run()">
        <v-list-tile-title>{{ action.caption() }}</v-list-tile-title>
      </v-list-tile>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
  import classes from '../../api/classes'
  export default {
    name: 'ops-btn',
    props: {
      cxt: {
        type: Object,
        default () {
          return new classes.MultiSelectContext(() => [])
        }
      },
      flat: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {
        menu: false
      }
    },
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.xsOnly
      }
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// OpsBtn.vue?5a06d8ce